import PropTypes from 'prop-types';

import ProductRating from '@/components/common/product/rating/ProductRating';

export const ProductRatingContainer = ({ topRating, ratings, scrollToRatings }) => {
  const completeTopRating = ratings.filter((rating) => rating.name === topRating?.name);
  return ratings.length > 0 ? (
    <ProductRating
      ratingsCount={ratings.length - 1}
      topRating={completeTopRating[0] ?? ratings[0]}
      scrollToRatings={scrollToRatings}
    />
  ) : null;
};

ProductRatingContainer.propTypes = {
  ratings: PropTypes.array.isRequired,
  scrollToRatings: PropTypes.func,
  topRating: PropTypes.object
};

export default ProductRatingContainer;
